import { client } from '@/client';
import { Course } from '@/client/courses';
import {
  HubspotEventType,
  HubspotProperty,
  HubspotValue,
  HubspotValueType,
} from '@/client/hubspot/types';
import { User } from '@/client/users';
import moment from 'moment';

export const hubspotTrack = (
  event: HubspotProperty,
  value: HubspotValue | string,
  type = HubspotEventType.GENERIC,
  valueType?: HubspotValueType,
) => {
  const track = async () => {
    await client.hubspot.trackEvent({
      type,
      event,
      value,
      valueType,
    });
  };

  track();
};

export const hubspotTrackMaterialDownloaded = (course: Course) => {
  const hubspotProperty = course?.hubspotProperties?.hubspotProperty;
  const hubspotDateProperty = course.hubspotProperties?.hubspotDateProperty;

  if (hubspotProperty) {
    hubspotTrack(
      hubspotProperty as HubspotProperty,
      HubspotValue.YES,
      HubspotEventType.COURSE,
      HubspotValueType.BOOLEAN,
    );
  }

  if (hubspotDateProperty) {
    hubspotTrack(
      hubspotDateProperty as HubspotProperty,
      hubspotTimestamp(),
      HubspotEventType.COURSE,
      HubspotValueType.DATE,
    );
  }
};

export const identifyHubspotContact = (user: User) => {
  const _hsq =
    typeof window !== 'undefined' && (window as any)._hsq
      ? (window as any)._hsq
      : [];

  _hsq.push([
    'identify',
    {
      [HubspotProperty.ID]: user.id,
      [HubspotProperty.EMAIL]: user.email,
      [HubspotProperty.FIRSTNAME]: user.firstName,
      [HubspotProperty.LASTNAME]: user.lastName,
      [HubspotProperty.COMPANY]: user?.account?.name,
      [HubspotProperty.USER_LOGIN]: HubspotValue.YES,
    },
  ]);
  _hsq.push(['trackPageView']);
};

export const revokeHubspotCookies = () => {
  const _hsq =
    typeof window !== 'undefined' && (window as any)._hsq
      ? (window as any)._hsq
      : [];

  _hsq.push(['revokeCookieConsent']);
};

export const hubspotTimestamp = () =>
  moment().startOf('day').utc(true).toISOString();

export const getHubspotIsActiveStatus = (
  status: string | undefined,
): boolean => {
  if (!status) return false;
  switch (status) {
    case 'Onboarding':
    case 'Active':
    case 'Offboarding':
    case 'Free trial':
    case 'Completed One-off':
      return true;
    default:
      return false;
  }
};
